import { type PoweredByDisclaimer } from '@/modules/case';
import { getAssetUrlByPath } from '@/modules/case/utils/asset-loader';

type Props = {
  disclaimer: PoweredByDisclaimer;
  assetsBaseUrl: string;
};

function PoweredByDisclaimer({ disclaimer, assetsBaseUrl }: Props) {
  return (
    <div className="relative flex h-full w-full flex-col items-center pb-32  text-gray-500">
      {/* Powered By */}
      <div className="powered text-center">{disclaimer.poweredBy}</div>
      {/* Logos */}
      <div className="-mx-[25px] flex flex-wrap justify-center gap-y-[50px] pt-5">
        {disclaimer.logos.map((logoPath) => (
          <div key={logoPath} className="animate-fade-in">
            <img
              className="h-20 object-contain"
              alt="logo"
              src={getAssetUrlByPath(assetsBaseUrl, logoPath)}
            />
          </div>
        ))}
      </div>

      {/* Title */}
      {disclaimer.title && (
        <div className="title w-full max-w-[800px] pt-[5%] text-center  lg:text-[2em] font-semibold">
          {disclaimer.title}
        </div>
      )}
      {/* Main Logo - Primary Focus */}
      {disclaimer.main_logo && (
        <div className="flex w-full flex-1 animate-fade-in items-center justify-center py-2 lg:py-8">
          <img
            className="max-h-[40vh] w-full max-w-[min(800px,90vw)] object-contain"
            alt="main logo"
            src={getAssetUrlByPath(assetsBaseUrl, disclaimer.main_logo)}
          />
        </div>
      )}
      {/* Disclaimer Section */}
      <div className="disclaimer absolute bottom-0 flex w-full flex-wrap items-end justify-between gap-1 lg:gap-4 pb-4 text-[0.8em]">
        <div className="block flex-[0_0_100%] md:flex-[0_0_45.833%]">
          <div className="flex flex-wrap ">DISCLAIMER</div>
          <div>{disclaimer.disclaimer}</div>
        </div>
        <div className="flex-[0_0_100%] text-left md:flex-[0_0_45.833%] md:text-right">
          {disclaimer.revision}
        </div>
      </div>
    </div>
  );
}

export default PoweredByDisclaimer;
